/* eslint-disable */

// Creates the selectedProducts object from the defaultPack
export const generateSelectedProductsFromDefaultPack = (defaultPack) => {
    let result = {};

    defaultPack.forEach(group => {
        if (group.IsIncludedTypeGroup) return;

        const groupId = group.GroupID;

        if(groupId in result) {
            group.Products.forEach(product => {
                const productId = product.ProductID;
                const quantity = product.Quantity;

                if(productId in result[groupId]) {
                    result[groupId][productId] += quantity;
                } else {
                    result[groupId][productId] = quantity;
                }
            });
        } else {
            result[groupId] = {};
            group.Products.forEach(product => {
                result[groupId][product.ProductID] = product.Quantity;
            });
        }
    });

    return result;
};

export const generateSelectedProductsFromUpdatedDefaultPack = (sortedDefaultPack) => {
    let result = {};

    sortedDefaultPack.forEach(group => {
        if (group.IsIncludedTypeGroup) return;

        const groupId = group.GroupID;

        if(groupId in result) {
            group.MatchingProducts.forEach(product => {
                const productId = product.ID;
                const quantity = product.Quantity;

                if(productId in result[groupId]) {
                    result[groupId][productId] += quantity;
                } else {
                    result[groupId][productId] = quantity;
                }
            });
        } else {
            result[groupId] = {};
            group.MatchingProducts.forEach(product => {
                result[groupId][product.ID] = product.Quantity;
            });
        }
    });

    return result;
};

export const updatePackSummaryOnChange = (selectedProducts, packGroups, groupID) => {
    let selectedProductsData = JSON.parse(JSON.stringify(selectedProducts));
    let selectedProduct = null;
    let resultArray = [];
    let $packSummaryItems = $('.edit-packsummary-container .pack-summary .pack-summary__item');
    let $matchedElement = null;
    let $dynamicHtml;

    for (let productGroupID in selectedProductsData) {
        let productsToUpdate = selectedProductsData[productGroupID];
        if(productGroupID === groupID) {
            selectedProduct = productsToUpdate;
            break;
        }
    }

    for (let product in selectedProduct) {
        let selectedQuantity = selectedProduct[product];
        let matchingGroup = packGroups.find(group => group.GroupID === groupID);
        let maxQuantityForProduct = matchingGroup.MaxQuantity;

        if(matchingGroup) {
            let productsNewArray = matchingGroup.ProductsNew;

            // Loop through each item in the "ProductsNew" array
            for (let productItem of productsNewArray) {
                if(productItem.UnpackagedItem !== null) {
                    if(productItem.UnpackagedItem.ID === product) {
                        productItem.UnpackagedItem.ShortName = productItem.ShortName;
                        productItem.UnpackagedItem.HasFlavors = false;
                        productItem.UnpackagedItem.SelectedQuantity = selectedQuantity;
                        productItem.UnpackagedItem.MaxQuantity = maxQuantityForProduct;
                        resultArray.push(productItem.UnpackagedItem);
                        break;
                    }
                } else {
                    // "UnpackagedItem" is null
                    for (let packagingItem of productItem.Packaging) {
                        for (let flavorItem of packagingItem.Flavors) {
                            if(flavorItem.ID === product) {
                                flavorItem.ShortName = productItem.ShortName,
                                flavorItem.PackagingName = packagingItem.PackagingName,
                                flavorItem.HasFlavors = true;
                                flavorItem.SelectedQuantity = selectedQuantity;
                                flavorItem.MaxQuantity = maxQuantityForProduct;
                                resultArray.push(flavorItem);
                                break;
                            }
                        }
                    }
                }
            }
        }
    }

    $packSummaryItems.each(function(index, el) {
        if($(el).data('groupid') === groupID) {
            $matchedElement = $(el);
            return false;
        }
    });

    $matchedElement.find('.bottom').remove();

    let bottomContainer = $('<div class="bottom"><ul></ul></div>');
    $dynamicHtml = bottomContainer;
    if(resultArray.length > 0) {
        resultArray.forEach(item => {
            let html;
            if(item.HasFlavors) {
                html = `
                        <li>
                            <div class="list-item">
                            <div class="flavor-info">
                                <p>${item.ShortName}, ${item.PackagingName}, ${item.FlavorName} - <span>QTY: ${item.SelectedQuantity}</span></p>
                            </div>
                            ${item.UpchargeAmount > 0
        ? `
                            <div class="upcharge-wrapper">
                                <img src="/assets/images/pack-config/upcharge-icon.svg" alt="Upcharge Icon">
                                ${item.UpchargeDisplay}
                            </div>`
        : ''}
                            </div>
                        </li>
                        `;
            } else {
                html = `
                        <li>
                            <div class="list-item">
                            <div class="flavor-info">
                                <p>${item.Name} - <span>QTY: ${item.SelectedQuantity}</span></p>
                            </div>
                            ${item.UpchargeAmount > 0
        ? `
                                <div class="upcharge-wrapper">
                                    <img src="/assets/images/pack-config/upcharge-icon.svg" alt="Upcharge Icon">
                                    ${item.UpchargeDisplay}
                                </div>`
        : ''}
                            </div>
                        </li>
                        `;
            }
            $dynamicHtml.find('ul').append(html);
        });
        $matchedElement.append($dynamicHtml);
    }
};
